import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
} from "react-bootstrap";

import { AlertInfo } from "../../components/Alert/AlertInfo.jsx";
import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import { NavLink } from "react-router-dom";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables.jsx";

import Select from 'react-select';
import DateTimePicker from 'react-datetime-picker';


const restLink_flavor = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
});
const cloud_client = new ApolloClient({
  link: restLink_flavor,
  cache: new InMemoryCache(),
});

const ADD_TODO = gql`
  mutation createOrUpdateFlavor($id: Int!, $title: String!, $is_custom: Int!, $description: String!, $ram: Int!, $vcpu: Int!, $cost: String!){
    createOrUpdateFlavor(id:$id,input:{title: $title, is_custom: $is_custom, ram:$ram, vcpu:$vcpu, description:$description, cost:$cost}) {
      id
    }
  }
`;

const GET_FLAVOR = gql`
  query getFlavor($flavor_id: Int!){
    flavor(id:$flavor_id){
      id
      title
      description
      ram
      vcpu
      cost_format
      is_custom
    }
  }
`;

class FlavorItem extends Component {

  flavor_id;
  flavor_edit;

  constructor() {
    super();
    this.state = {
      alertInfo: "",
      datePublish: new Date(),
      dateUnpublish: null,
      is_custom: false
    };

    this.start_publish_date = true;
    this.start_unpublish_date = true;
    this.start_active = true;
    this.start_is_custom = true;
    
    
  }

  onChange_datePublish = datePublish => this.setState({ datePublish })
  onChange_dateUnpublish = dateUnpublish => this.setState({ dateUnpublish })

  handleCheckboxChange = (e) => {
    this.setState(state => ({
      ...state,
      checkboxValue_active: !this.state.checkboxValue_active
    }));

  }

  checkboxValue_is_custom = (e) => {
    this.setState(state => ({
      ...state,
      is_custom: !this.state.is_custom
    }));

  }

  


  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      alertInfo: "Salvo com sucesso!"
    });

    setTimeout(() => {
      this.setState({
        alertInfo: ""
      })
    },3000);
  }

  
  render() {

    
    if(this.props.match.params.id) {
      this.flavor_id = this.props.match.params.id;
    } else {
      this.flavor_id = 0;
    }

    return (


      <Query
      client={cloud_client}
      query={GET_FLAVOR}
      variables={{flavor_id:this.flavor_id}}
      >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error) return <div>Erro :(</div>;
          
          this.flavor_edit = data.flavor;

          if(this.start_is_custom && this.flavor_edit && this.flavor_edit.is_custom) {
            this.start_is_custom = false;
            console.log(this.flavor_edit.is_custom);
            this.setState({
              is_custom: (this.flavor_edit.is_custom === 1 ? true : false)
            })
          }

        return (

      <Mutation mutation={ADD_TODO} client={cloud_client}>
      {(createOrUpdateFlavor, { data }) => (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>

            <NavLink
                to="/Flavor"
                className="btn btn-info btn-fill"
                activeClassName=""
              >
              VOLTAR
            </NavLink>
            <NotificationSystem ref="notificationSystem" style={style} />
            
              <Card
                title="Modelo"
                content={
                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                    createOrUpdateFlavor({variables: { 
                      id: this.flavor_id, 
                      title: e.target.elements.title.value,
                      description: e.target.elements.description.value,
                      ram: e.target.elements.ram ? e.target.elements.ram.value*1024 : 0,
                      vcpu: e.target.elements.vcpu ? e.target.elements.vcpu.value : 0,
                      cost: e.target.elements.cost ? e.target.elements.cost.value : "0,00",
                      is_custom: (e.target.elements.is_custom.checked ? 1 : 0),
                    } });
                  }}
                  >

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "title",
                        label: "Título",
                        type: "text",
                        bsClass: "form-control",
                        placeholder: "Título",
                        defaultValue: (this.flavor_edit ? this.flavor_edit.title : "")
                      }
                    ]}
                  />


                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "description",
                        label: "Descrição",
                        type: "text",
                        bsClass: "form-control",
                        placeholder: "Descrição",
                        defaultValue: (this.flavor_edit ? this.flavor_edit.description : "")
                      }
                    ]}
                  />

                  <FormGroup>
                    <ControlLabel>
                      <input
                        value="1"
                        name="is_custom"
                        type="checkbox"
                        checked={this.state.is_custom}
                        onChange={this.checkboxValue_is_custom}
                      /> VM Customizada
                    </ControlLabel>
                  </FormGroup>

                    {
                      !this.state.is_custom && 
                      <div>
                        <FormInputs
                          ncols={["col-md-12"]}
                          proprieties={[
                            {
                              name: "ram",
                              label: "RAM (GB)",
                              type: "number",
                              bsClass: "form-control",
                              placeholder: "RAM (GB)",
                              defaultValue: (this.flavor_edit ? this.flavor_edit.ram / 1024 : "")
                            }
                          ]}
                        />
                        <FormInputs
                          ncols={["col-md-12"]}
                          proprieties={[
                            {
                              name: "vcpu",
                              label: "VCPUs",
                              type: "number",
                              bsClass: "form-control",
                              placeholder: "VCPUs",
                              defaultValue: (this.flavor_edit ? this.flavor_edit.vcpu : "")
                            }
                          ]}
                        />

                        <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                name: "cost",
                                label: "Valor por hora (R$)",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Valor por hora (R$)",
                                defaultValue: (this.flavor_edit && this.flavor_edit.cost_format ? this.flavor_edit.cost_format : "0,00")
                              }
                            ]}
                          />
                      </div>
                    }



                  <Row>
                    <Col md={10}>
                      <AlertInfo ref="alertSave" alertInfo={this.state.alertInfo} />
                    </Col>
                    <Col md={2}>
                      <Button bsStyle="info" pullRight fill type="submit">
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                    <div className="clearfix" />
                  </form>
                }
              />

       
            
            </Col>
            
          </Row>
        </Grid>
      </div>
      )}
      </Mutation>

      );
      }}
      </Query>
    );
  }
}

export default FlavorItem;
